import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "download-bar" }
const _hoisted_2 = { class: "brand" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "brand-name" }
const _hoisted_5 = { class: "drama-main" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "content" }
const _hoisted_8 = {
  key: 0,
  class: "poster-wrap"
}
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = {
  key: 1,
  class: "drama-info"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "qr-block" }
const _hoisted_14 = { class: "qr-card" }

import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { QrcodeSvg } from 'qrcode.vue';
import { DramaDetail, getDramaDetail } from '@/api/drama';
import i18n from '@/language';
import useDownloadApp from '@/hooks/useDownloadApp';
import useOpenApp from '@/hooks/useOpenApp';
import envoMark from '@/assets/img/drama/logo.png';
import envoLogoDark from '@/assets/img/logo-text-dark.png';
import envoLogoLight from '@/assets/img/envo-icon-post/logo.svg';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const qrcodeValue = ref('');
const dramaDetail = ref<DramaDetail>();
const route = useRoute();
const t = i18n.global.t;
const { openApp } = useOpenApp();
const { downloadApp } = useDownloadApp();
const isDarkTheme = computed(() => route.query.theme === 'dark');
const envoLogo = computed(() =>
  isDarkTheme.value ? envoLogoDark : envoLogoLight,
);

const qrLogoSettings = computed(() => ({
  src: envoMark,
  width: 40,
  height: 40,
  excavate: true,
}));

const dramaId = computed(() => {
  const id = route.params.id || route.query.id;
  return Array.isArray(id) ? id[0] : id;
});

const dramaCover = computed(() => dramaDetail.value?.dramaCover || '');
const dramaName = computed(() => dramaDetail.value?.dramaName || '');
const episodeText = computed(() => {
  const detail = dramaDetail.value;
  if (!detail) return '';
  if (
    detail.totalEpisodes &&
    detail.currentEpisodes &&
    detail.totalEpisodes === detail.currentEpisodes
  ) {
    return t('全{count}集', { count: detail.currentEpisodes });
  }
  if (detail.currentEpisodes) {
    return t('更新至{count}集', { count: detail.currentEpisodes });
  }
  if (detail.totalEpisodes) {
    return t('全{count}集', { count: detail.totalEpisodes });
  }
  return detail.dramaStatus === 2 ? t('已完结') : t('更新中');
});

const getDramaDetailApi = async () => {
  if (!dramaId.value) return;
  try {
    const res = await getDramaDetail(dramaId.value as string);
    dramaDetail.value = res.value?.result;
  } catch (error) {}
};

onMounted(() => {
  qrcodeValue.value = window.location.href;
  getDramaDetailApi();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['drama-page', { 'is-light': !isDarkTheme.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          class: "brand-logo",
          src: envoLogo.value,
          alt: "Envo"
        }, null, 8, _hoisted_3),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "divider" }, null, -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('Envo短剧')), 1)
      ]),
      _createElementVNode("button", {
        class: "download-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(downloadApp)()))
      }, _toDisplayString(_ctx.$t('XZ')), 1)
    ]),
    _createElementVNode("main", _hoisted_5, [
      (dramaCover.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "bg-poster",
            src: dramaCover.value,
            alt: ""
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "bg-mask" }, null, -1)),
      _createElementVNode("section", _hoisted_7, [
        (dramaCover.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("img", {
                class: "poster",
                src: dramaCover.value,
                alt: dramaName.value
              }, null, 8, _hoisted_9)
            ]))
          : _createCommentVNode("", true),
        (dramaName.value || episodeText.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (dramaName.value)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_11, _toDisplayString(dramaName.value), 1))
                : _createCommentVNode("", true),
              (episodeText.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(episodeText.value), 1))
                : _createCommentVNode("", true),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "info-line" }, null, -1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (qrcodeValue.value)
              ? (_openBlock(), _createBlock(_unref(QrcodeSvg), {
                  key: 0,
                  class: "qr-code",
                  value: qrcodeValue.value,
                  size: 158,
                  margin: 0,
                  level: "H",
                  background: "#ffffff",
                  foreground: "#000000",
                  "image-settings": qrLogoSettings.value
                }, null, 8, ["value", "image-settings"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('请使用手机端「Envo App」扫码观看')), 1)
        ]),
        _createElementVNode("button", {
          class: "watch-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(openApp) && _unref(openApp)(...args)))
        }, _toDisplayString(_ctx.$t('观剧')), 1)
      ])
    ])
  ], 2))
}
}

})